import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import { getAdmin, getArbitrationAgreement, setProgressionProperties } from '../../../../../../reducers/onboarding';
import Signature from '../../../../../../components/signature';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';

class ContractorArbitrationStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'ContractorArbitrationStep' } });

        const { role, admin, client, job, signatureList, arbitrationAgreement, getSignatures, setProgressionProperties, getArbitrationAgreement } = this.props;

        if (!arbitrationAgreement) {
            getArbitrationAgreement(job.id, role.id, role.type, 'arbitration');
        }

        if (!signatureList) {
            getSignatures(role, result => {
                setProgressionProperties({
                    arbitrationSigned: result.find(s => s.name === `${Signatures.types.ARBITRATION.name}:${job.id}`) !== undefined
                });
            });
        }

        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submit(action) {
        const { sign, setProgressionProperties, role, job } = this.props;
        sign(role, `${Signatures.types.ARBITRATION.name}:${job.id}`, () => {
            setProgressionProperties({ arbitrationSigned: true });
            action();
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, job, signatureList, admin, arbitrationAgreement } = this.props;
        if (!signatureList || !admin || !arbitrationAgreement) {
            return null;
        }

        return (
            <div>
                <form onSubmit={handleSubmit(() => this.submit(onSubmit))}>
                    <div className="row section">
                        <div className="col-xs-12">
                            <div className="scrolled">{getArbitrationAgreement(admin)}</div>
                            <div className="scrolled" dangerouslySetInnerHTML={{ __html: arbitrationAgreement }} />
                        </div>
                        <div className="col-xs-12">
                            <Signature name={`${Signatures.types.ARBITRATION.name}:${job.id}`} />
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
                </form>
            </div>
        );
    }
}

ContractorArbitrationStep = reduxForm(formSettings)(ContractorArbitrationStep);

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        admin: state.onboarding.admin,
        signatureList: state.signatures.list,
        client: state.onboarding.client,
        arbitrationAgreement: state.onboarding.arbitrationAgreement,
        isSigned: state.onboarding.progression.arbitrationSigned
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin,
            sign,
            getArbitrationAgreement,
            getSignatures,
            setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorArbitrationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/contractorArbitration.jsx